import { Blob, NS3451 } from '@consigli/types';
import { DragEndEvent, DragStartEvent, Modifier, UniqueIdentifier } from '@dnd-kit/core';
import { getEventCoordinates } from '@dnd-kit/utilities';

import { FolderDocumentsType } from '@/util/types';

export const snapCenterToCursor: Modifier = (({
  activatorEvent,
  draggingNodeRect,
  transform,
}: {
  activatorEvent: Event | null;
  draggingNodeRect: ClientRect | null;
  transform: { x: number; y: number; scaleX: number; scaleY: number };
}) => {
  if (draggingNodeRect && activatorEvent) {
    const activatorCoordinates = getEventCoordinates(activatorEvent);

    if (!activatorCoordinates) {
      return transform;
    }

    const offsetX = activatorCoordinates.x - draggingNodeRect.left;
    const offsetY = activatorCoordinates.y - draggingNodeRect.top;

    return {
      ...transform,
      x: transform.x + offsetX - draggingNodeRect.width / 30,
      y: transform.y + offsetY - draggingNodeRect.height / 2,
      scaleX: transform.scaleX,
      scaleY: transform.scaleY,
    };
  }

  return transform;
}) as Modifier;

export const handleDragStart = (
  event: DragStartEvent | null,
  selectedFiles: FolderDocumentsType[],
  setSelectedFiles: (files: FolderDocumentsType[]) => void,
  setDraggingCardId: (id: UniqueIdentifier) => void,
) => {
  if (!event) {
    setDraggingCardId('');
    return;
  }

  const filterValues = selectedFiles.map((item: FolderDocumentsType) => item.id);
  setSelectedFiles(filterValues.includes(String(event.active.id)) ? selectedFiles : []);
  setDraggingCardId(event.active.id);
};

export const handleDragEnd = async (
  event: DragEndEvent,
  activeFolderFiles: Blob[],
  setActiveDraggedFile: (file: Blob | null) => void,
  setSelectedFolderForDrag: (id: UniqueIdentifier) => void,
  setDraggingCardId: (id: UniqueIdentifier) => void,
  setConfirmationPopupIsOpen: (open: boolean) => void,
  handleUpdateBlobs: (
    operation: 'copy' | 'move',
    folderId: UniqueIdentifier,
    file?: Blob,
  ) => Promise<void>,
) => {
  if (event.over === null) {
    setDraggingCardId('');
    return;
  }

  const currentDraggedFile = activeFolderFiles.find((x) => x.id === event.active.id);
  const selectedFolderForDrag = event.over.id;

  if (!currentDraggedFile) {
    throw new Error(
      `Attempted to complete drop with file ${event.active.id} which does not exist in context state`,
    );
  }

  setActiveDraggedFile(currentDraggedFile);
  setSelectedFolderForDrag(selectedFolderForDrag);

  if (selectedFolderForDrag === NS3451.UNCATEGORIZED) {
    await handleUpdateBlobs('move', selectedFolderForDrag, currentDraggedFile);
  } else {
    setConfirmationPopupIsOpen(true);
  }
};
